// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
   apiEndpoints:{
    users: 'https://api.dev.askmi.de',
    showrooms: 'https://api.dev.askmi.de',
    products: 'https://api.dev.askmi.de',
    company: 'https://api.dev.askmi.de/company',
    agb: 'https://api.dev.askmi.de/agb',
    media: 'https://api.dev.askmi.de/media'
  },
  node_env: 'local'
};

/*export const environment = {
  production: false,
  apiEndpoints: {
    users: 'http://localhost:3001',
    showrooms: 'http://localhost:3001',
    products: 'http://localhost:3001',
    company: 'http://localhost:3001/company',
    agb: 'http://localhost:3001/agb',
    media: 'http://localhost:3001/media'
  },
  node_env: 'local'
};*/

/*
export const environment = {
    production: false,
    apiEndpoints:{
        users: process.env.API_URL,
        showrooms: process.env.API_URL,
        products: process.env.API_URL,
        company: process.env.API_URL + '/company',
        agb: process.env.API_URL + '/agb',
        media: process.env.API_URL + '/media',
    },
    node_env: process.env.node_env
};
*/


// export const environment = {
//     production: false,
//     apiEndpoints:{
//         users: 'https://api.dev.askmi.de',
//         showrooms: 'https://api.dev.askmi.de',
//         products: 'https://api.dev.askmi.de'
//     }
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
